import Vue from "vue";
import VCalendar from 'v-calendar';
// import 'v-calendar/styles/base.css';

Vue.use(VCalendar, {
  componentPrefix: 'vc',
})
